module.exports = __webpack_public_path__ + "static/media/keys.52104407.JPG";